// import { db } from "../../../../firebase.config";
// import { doc, deleteDoc } from "firebase/firestore";
import { updateStatusInfo } from "../../../../Features/statusInfo";
import { projectInfo } from "../../../../Features/roofInfo";
import { updateQuantityInfo } from "../../../../Features/quantityInfo";
import { kiloToMegaWatt } from "../../summaryReport/projectOverview";

export const handleSearchInputChange = (
  e,
  projectList,
  setFilteredProjectList
) => {
  console.log(e.target.value);
  const searchTerm = e.target.value.toLowerCase();
  const filtered = projectList.filter((project) => {
    const customerName = project.customerName.toLowerCase();
    const siteName = project.value.siteName.toLowerCase();
    const siteAddress = project.value.siteAddress.value.toLowerCase();
    const status = project.statusInfo.status.toLowerCase();
    const siteDate = new Date(project.value.siteDate)
      .toLocaleDateString()
      .toLowerCase();
    return (
      customerName.includes(searchTerm) ||
      siteName.includes(searchTerm) ||
      siteAddress.includes(searchTerm) ||
      siteDate.includes(searchTerm) ||
      status.includes(searchTerm)
    );
  });

  setFilteredProjectList(filtered);
};

export const handleDelete = async (
  id,
  setProjectList,
  setFilteredProjectList,
  setShow,
  setAlert
) => {
  try {
    // const projectRef = doc(db, "projects", id);
    // await deleteDoc(projectRef);
    setProjectList((prevList) =>
      prevList.filter((project) => project.id !== id)
    );
    setFilteredProjectList((prevList) =>
      prevList.filter((project) => project.id !== id)
    );

    setShow(false);
    setAlert(true);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

export const statusColors = {
  Draft: "#868E96",
  Completed: "#28A745",
  "In Progress": "#17A2B8",
  Pending: "#FFC107",
};

let statsValues = {
  Draft: { quantity: 0, capacity: 0 },
  Completed: { quantity: 0, capacity: 0 },
  "In Progress": { quantity: 0, capacity: 0 },
  Pending: { quantity: 0, capacity: 0 },
  fetched: false,
};

export const getCapacity = (roofData) => {
  let capacity = 0;
  if (roofData.length > 0) {
    for (let i = 0; i < roofData.length; i++) {
      const elem = roofData[i];
      if (elem.structureType === "Single") {
        capacity += Number(elem.totalKilowatt);
      } else {
        for (let j = 0; j < elem.multipleStructure.length; j++) {
          const element = elem.multipleStructure[j];
          capacity += Number(element.totalKilowatt);
        }
      }
    }
  }
  let value = kiloToMegaWatt(capacity);
  return value;
};

export const getKilowatt = (roofData) => {
  let capacity = 0;
  if (roofData.length > 0) {
    for (let i = 0; i < roofData.length; i++) {
      const elem = roofData[i];
      if (elem.structureType === "Single") {
        capacity += Number(elem.totalKilowatt);
      } else {
        for (let j = 0; j < elem.multipleStructure.length; j++) {
          const element = elem.multipleStructure[j];
          capacity += Number(element.totalKilowatt);
        }
      }
    }
  }

  let value = Number(capacity);

  return value;
};

export const getTotalKiloWatt = (filteredProjectList, dispatch) => {
  if (!statsValues.fetched)
    filteredProjectList.map((project) => {
      statsValues[project.statusInfo.status].quantity += 1;
      statsValues[project.statusInfo.status].capacity += project?.value
        ?.capacity
        ? parseFloat(project.value.capacity)
        : getKilowatt(project.quantityInfo.roofData);
      return statsValues[project.statusInfo.status];
    });
  statsValues.fetched = true;
  dispatch(updateStatusInfo({ statsValues }));
};

export const projectCapacity = (data) => {
  let capacity = 0;
  if (data?.value?.capacity) {
    capacity = data.value.capacity;
  } else {
    const roofData = data.quantityInfo.roofData;
    if (roofData.length > 0) {
      for (let i = 0; i < roofData.length; i++) {
        const elem = roofData[i];
        if (elem.structureType === "Single") {
          capacity += Number(elem.totalKilowatt);
        } else {
          for (let j = 0; j < elem.multipleStructure.length; j++) {
            const element = elem.multipleStructure[j];
            capacity += Number(element.totalKilowatt);
          }
        }
      }
    }
  }
  let value = kiloToMegaWatt(capacity)
  return value
};

export const handleEditProject = (id, projectList, navigate, dispatch) => {
  const selectedProject = projectList.find((project) => project.id === id);
  sessionStorage.setItem("projectId", id);
  const value = selectedProject.value;
  dispatch(projectInfo({ value: value }));
  dispatch(updateQuantityInfo(selectedProject.quantityInfo));
  navigate("/createProject");
};

export const sortByUpdateDate = (
  list,
  setProjectList,
  setFilteredProjectList,
  setStatusSort
) => {
  const listed = [...list].sort(
    (a, b) =>
      new Date(b.statusInfo.updateDate) - new Date(a.statusInfo.updateDate)
  );
  setProjectList(listed);
  setFilteredProjectList(listed);
  setStatusSort(true);
};

export const sortByInstallationDate = (
  list,
  setProjectList,
  setFilteredProjectList,
  setInstallationSort
) => {
  const listed = [...list].sort(
    (a, b) =>
      new Date(b.value.dateOfInstallation) -
      new Date(a.value.dateOfInstallation)
  );
  setProjectList(listed);
  setFilteredProjectList(listed);
  setInstallationSort(true);
};

export const sortByUpdateDateAscending = (
  list,
  setProjectList,
  setFilteredProjectList,
  setStatusSort
) => {
  const listed = [...list].sort(
    (a, b) =>
      new Date(a.statusInfo.updateDate) - new Date(b.statusInfo.updateDate)
  );
  setProjectList(listed);
  setFilteredProjectList(listed);
  setStatusSort(false);
};

export const sortByInstallationDateAscending = (
  list,
  setProjectList,
  setFilteredProjectList,
  setInstallationSort
) => {
  const listed = [...list].sort(
    (a, b) =>
      new Date(a.value.dateOfInstallation) -
      new Date(b.value.dateOfInstallation)
  );
  setProjectList(listed);
  setFilteredProjectList(listed);
  setInstallationSort(false);
};

export const sortByCapacityAscending = (
  list,
  setProjectList,
  setFilteredProjectList,
  setCapacitySort
) => {
  const listed = [...list].sort((a, b) => a.value.capacity - b.value.capacity);
  setProjectList(listed);
  setFilteredProjectList(listed);
  setCapacitySort(false);
};

export const sortByCapacity = (
  list,
  setProjectList,
  setFilteredProjectList,
  setCapacitySort
) => {
  const listed = [...list].sort((a, b) => b.value.capacity - a.value.capacity);
  setProjectList(listed);
  setFilteredProjectList(listed);
  setCapacitySort(true);
};
